import React from 'react';
import { SelectMenu } from '@scale/scaleui';
import { AttachmentMetadataType } from '@scale/shared/types/chat';

interface AttachmentsChoicesBuilderProps {
  name: string;
  existingValue?: AttachmentMetadataType;
  updateProperty: (arg: AttachmentMetadataType) => void;
  required?: boolean;
}

interface AttachmentOption {
  id: AttachmentMetadataType;
  name: string;
}

const attachmentOptions: Array<AttachmentOption> = [
  { id: AttachmentMetadataType.Email, name: AttachmentMetadataType.Email },
  { id: AttachmentMetadataType.Image, name: AttachmentMetadataType.Image },
  { id: AttachmentMetadataType.IFrame, name: AttachmentMetadataType.IFrame },
];

const AttachmentsChoicesBuilder: React.FC<AttachmentsChoicesBuilderProps> = ({
  name,
  existingValue,
  updateProperty,
  required,
}) => {
  return (
    <div className="flex flex-col items-start">
      <div className="flex items-center">
        {name && <div className="my-1 text-sm font-medium leading-6 text-neutral-700">{name}</div>}
      </div>
      <SelectMenu
        className="w-36"
        options={attachmentOptions}
        selectedOptionId={existingValue || AttachmentMetadataType.Email}
        setSelected={value => {
          updateProperty(value as AttachmentMetadataType);
        }}
        required={required}
      />
    </div>
  );
};

export default AttachmentsChoicesBuilder;
